import { render, staticRenderFns } from "./editPlateformCompany.vue?vue&type=template&id=793fa57c&scoped=true"
import script from "./editPlateformCompany.vue?vue&type=script&lang=js"
export * from "./editPlateformCompany.vue?vue&type=script&lang=js"
import style0 from "./editPlateformCompany.vue?vue&type=style&index=0&id=793fa57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793fa57c",
  null
  
)

export default component.exports